import classNames from "classnames";
import { ComponentPropsWithoutRef, FC } from "react";

import styles from "./RadioPanel.module.css";

type Props = ComponentPropsWithoutRef<"input"> & {
  label: string;
};

const RadioPanel: FC<Props> = ({
  label,
  checked,
  children,
  className,
  ...rest
}) => {
  return (
    <label className={classNames(styles.wrapper, className)} tabIndex={-1}>
      <div className={styles.header}>
        <input
          type="radio"
          className={styles.inputRadio}
          checked={checked}
          {...rest}
        />

        <span className={styles.radioOuterCircle}>
          {checked && <span className={styles.radioInnerCircle} />}
        </span>

        {label}
      </div>
      {children && <div className={styles.body}>{children}</div>}
    </label>
  );
};

export default RadioPanel;
